import {
    HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE,
    HIDE_SURVEY_GROUP_QUESTION_LOADER,
    SHOW_SURVEY_GROUP_QUESTION_LOADER,
    ON_ADD_SURVEY_GROUP_QUESTION,
    ON_SURVEY_GROUP_QUESTION_CLOSE,
    ON_DELETE_SURVEY_GROUP_QUESTION,
    ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER,
    CLEAR_SESSION,
} from 'constants/ActionTypes';

const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No survey groups found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: 'All survey groups',
    allSurveyGroupQuestion: [],
    surveyGroupQuestionList: [],
    selectedSurveyGroupQuestion: null,
    selectedSurveyGroupQuestions: 0,
    addSurveyGroupQuestionState: false,
    searchSurveyGroupQuestion: '',
    surveyGroupQuestion: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case ON_ADD_SURVEY_GROUP_QUESTION: {
            return { ...state, addSurveyGroupQuestionState: true };
        }
        case ON_SURVEY_GROUP_QUESTION_CLOSE: {
            return { ...state, addSurveyGroupQuestionState: false };
        }
        case ON_DELETE_SURVEY_GROUP_QUESTION: {
            return {
                ...state,
                alertMessage: 'Survey Group Question Deleted Successfully',
                showMessage: true,
                allSurveyGroupQuestion: state.allSurveyGroupQuestion.filter((surveyGroupQuestion) => surveyGroupQuestion.id !== action.payload.id),
                surveyGroupQuestionList: state.allSurveyGroupQuestion.filter((surveyGroupQuestion) => surveyGroupQuestion.id !== action.payload.id),
            };
        }
        case HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_SURVEY_GROUP_QUESTION_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_SURVEY_GROUP_QUESTION_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/SurveyGroupQuestion.js